import React from 'react';
import NavBarItemCollection from '../MenuLeft/NavBarItem/NavBarItemCollection';
import NavBarItemHome from '../MenuLeft/NavBarItem/NavBarItemHome';
import NavBarItemLoveSong from '../MenuLeft/NavBarItem/NavBarItemLoveSong';
import NavBarItemSearch from '../MenuLeft/NavBarItem/NavBarItemSearch';
import './MenuAction.scss';
function MenuAction(props) {
    return (
        <div className="Menu-action-mobile">
            <NavBarItemHome />
            <NavBarItemSearch />
            <NavBarItemCollection />
            <NavBarItemLoveSong />
        </div>
    );
}

export default MenuAction;